jQuery(document).ready(function ($) {
	
	var checkForUTMs = (function(){
		
		var utmParams;
		
		if (sessionStorage.getItem("session_utms") === null) {

			//check url for utms and refer

				//start by grabbing all parameters and creating an array
				var allParams = window.location.search.replace('?', '').split('&');

				//loop through the array and create an object with they key and values
				var objParams = {};
				allParams.map(function (val) {
					var arrPair = val.split('=');
					objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
				});

				console.log( 'Here are all the parameters' );
				console.log( objParams );

				//remove anything that is not a utm
				var filterObj = function filterObj(obj, str) {
					return Object.keys(obj).filter(function (i) {
						return i.substring(0, str.length) === str;
					}).reduce(function (o, k) {
						o[k] = obj[k];
						return o;
					}, {});
				};

				utmParams = filterObj(objParams, 'utm_');

				console.log('Here are the parameters filtered down to only utms');
				console.log(utmParams);

				//check for referall site
				var referallSite = '';
				var currentURL = location.href.match(/:\/\/(.[^/]+)/)[1];
				if (document.referrer) {
					var refURL = document.referrer; 
					referallSite = refURL.match(/:\/\/(.[^/]+)/)[1];
					if( referallSite != currentURL ){
						utmParams['utm_referall'] = referallSite;
					}
				}

				//add referall site to objParams
				console.log('added the referall site if it existed');
				console.log(utmParams);


			//find out what the source should be

				var source = '';

				var socials = ['www.facebook.com', 'www.m.facebook.com', 'www.twitter.com', 'www.instagram.com', 'www.linkedin.com', 'www.yelp.com', 'www.pinterest.com'];

				var searchEngines = ['www.google.com', 'www.yahoo.com', 'www.bing.com'];

				//if there is no utms and no referall source is direct
				if( utmParams['utm_source'] == undefined && utmParams['utm_medium'] == undefined && utmParams['utm_referall'] == undefined ){
					source = 'Direct'
                }else{


                    //if there is no source and no medium source is either organic or a referall
                    if( utmParams['utm_source'] == undefined && utmParams['utm_medium'] == undefined  ){
                        if( (searchEngines.indexOf(utmParams['utm_referall']) > -1) ){
                            source = 'Organic';
                        }else if( (socials.indexOf(utmParams['utm_referall']) > -1) ){
                            source = 'Social';
                        }else{
                            source = 'Referall';
                        }
                    }
                    
                    //if there is a medium its either ppc or paid social
                    if( utmParams['utm_medium'] == 'cpc' ){
                        source = 'PPC';
                    }else if( utmParams['utm_medium'] == 'paid-social' ){
                        source = 'Paid Social';
                    }else if( utmParams['utm_medium'] == 'referall' && (socials.indexOf(utmParams['utm_medium']) > -1) ){
                        source = 'Social';
                    }else if( utmParams['utm_medium'] == 'social' ){
                        source = 'Social';
                    }


                    // if there is a utm_source it should be email
                    if( utmParams['utm_source'] == 'email' ){
                        source = 'Email';
                    }else if( utmParams['utm_source'] == 'cancertutor' ){
                        console.log('asdasdasd asd a sda sd');
                        source = 'Cancer Tutor';
                    }

                    //check if the source is empty, if its check if it was social media
                    if( source != '' ){
                        console.log("Source was found it's " + source);
                        utmParams['utm_source'] = source;
                    }else{	   
                        console.log("No source was found");
                    }
                    
                }

				// Store
				sessionStorage.setItem("session_utms", JSON.stringify(utmParams));
			
		}else{
			utmParams = JSON.parse( sessionStorage.getItem('session_utms') );
			console.log( 'Found utms in session storage' );
			console.log(utmParams);
		}
		
		$utminputs = $('[class^="input-replace-utm_"]');
		$utminputs.each(function(){
			$(this).find('input').attr('value', '');
		});
		
		console.log('params are');
		console.log(utmParams);
			
		if( utmParams ){
			console.log('There is utms saved, going to write into form');
			$.each( utmParams, function( key, value ){
				
//				console.log(key);
				if( $('.input-replace-'+key+' input').length ){
					$('.input-replace-'+key+' input').attr('value', value);
//					console.log( 'Found ' + $('.input-replace-'+key+' input') + ' replacing value' );
				}

			});
		}
		
	}());

	
});